<template>
  <v-navigation-drawer
    :value.sync="drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    class="tw-pb-28 tw-border-0 md:tw-pb-0 md:tw-border-r-1 md:tw-border-light-gray md:tw-border-solid"
  >
    <!-- isValid isPdfDoc {{ isValid(selectedCompanyProductList.isPdfDoc) }}
    <br />
    isValid isEtax {{ isValid(selectedCompanyProductList.isEtax) }}
    <br />
    isValid isExchangeRate {{ isValid(selectedCompanyProductList.isExchangeRate) }} -->
     <!-- {{ selectedCompanyProductList }} -->
     <!-- userCompany {{ userCompany?.isAdmin }} -->
    <br />
    <div :class="`d-flex justify-center pt-5 pb-5`">
      <img
        src="@/assets/logo_phasi_charoen.svg"
        alt="ภาษีเจริญ"
        width="120"
        style="cursor: pointer"
        @click="goHome"
      />
    </div>
    <v-list v-if="!isItemLoading" style="margin-top: 10%">
      <!-- // etax // -->
      <!-- Passes groupState + toggle handler so the "เอกสารการขาย"
           header (isHeader + groupId="etax-docs-sale") can collapse
           its 7 document-type children. Without these props the
           chevron would render but click would do nothing (list.vue
           emits `toggle-group` and the parent has to persist it). -->
      <template v-if="isValid(selectedCompanyProductList?.isEtax)">
        <div v-for="(item, index) in filteredItemsPSC" :key="index + '_psc'">
          <menu-list
            :item="item"
            :companyID="companyID"
            :groupState="groupState"
            @toggle-group="handleToggleGroup"
          ></menu-list>
        </div>
      </template>
      <!-- // Ar automation // -->
      <template v-if="isValid(selectedCompanyProductList?.isPdfDoc)">
        <div v-for="(item, index) in filteredItemsVendor" :key="index + '_vendor'">
          <menu-list :item="item" :companyID="companyID" :isPdfDoc="isValid(selectedCompanyProductList?.isPdfDoc)"></menu-list>
        </div>
      </template>
      <!-- // exchange rate // -->
      <div v-if="isValid(selectedCompanyProductList?.isExchangeRate)">
        <div v-for="(item, index) in visibleExchangeItems" :key="index + '_exchange'">
          <menu-list :item="item" :companyID="companyID"></menu-list>
        </div>
      </div>
      <!-- // nsThaiSmartTax // -->
      <!-- One unified collapsible tree — VAT / WHT always visible when
           the company has isNsThaiSmartTax; the ภ.พ.36 and ภ.ง.ด.54
           groups (headers + every leaf inside them) are additionally
           gated by isNsThaiSmartPnd54Pp36 so a customer only sees the
           add-on sections after they've been enabled in
           settings/products. ภาษีซื้อเฉลี่ย is gated separately by
           isNsThaiSmartTaxAverage. -->
      <div v-if="isValid(selectedCompanyProductList?.isNsThaiSmartTax)">
        <div v-for="(item, index) in itemsNsThaiSmartTax" :key="index + '_nstax'">
          <!-- ภ.พ.36 / ภ.ง.ด.54 sections — gate the header AND every
               leaf by the product flag. `groupId` covers both because
               the header and its children share the same id. -->
          <template v-if="item.groupId === 'pp36' || item.groupId === 'pnd54'">
            <div v-if="selectedCompanyProductList?.isNsThaiSmartPnd54Pp36">
              <menu-list :item="item" :companyID="companyID" :isNsThaiSmartTax="isValid(selectedCompanyProductList?.isNsThaiSmartTax)" :groupState="groupState" @toggle-group="handleToggleGroup"></menu-list>
            </div>
          </template>
          <!-- ภาษีซื้อเฉลี่ย — separately gated by its own flag. -->
          <template v-else-if="item.link === 'Company.TaxBuyAverage'">
            <div v-if="selectedCompanyProductList?.isNsThaiSmartTaxAverage">
              <menu-list :item="item" :companyID="companyID" :isNsThaiSmartTax="isValid(selectedCompanyProductList?.isNsThaiSmartTax)" :groupState="groupState" @toggle-group="handleToggleGroup"></menu-list>
            </div>
          </template>
          <!-- Everything else — VAT + WHT items and headers, shown for
               any company with NS TST. -->
          <template v-else>
            <div>
              <menu-list :item="item" :companyID="companyID" :isNsThaiSmartTax="isValid(selectedCompanyProductList?.isNsThaiSmartTax)" :groupState="groupState" @toggle-group="handleToggleGroup"></menu-list>
            </div>
          </template>
        </div>
      </div>
      <!-- // top serv // -->
      <div v-if="isValid(selectedCompanyProductList?.isTopserv)">
        <div v-for="(item, index) in itemsTKC" :key="index + '_tkc'">
          <menu-list :item="item" :companyID="companyID"></menu-list>
        </div>
      </div>
  <!-- when on the “student” company, render the student items -->
   <div
     v-if="isStudentCompany"
     class="tw-mb-4"
   >
     <div
       v-for="(item, idx) in filteredStudentMenu"
       :key="`student_${idx}`"
     >
       <menu-list
          :item="item"
          :companyID="companyID"
          :isCompanyAdmin="userCompany?.isAdmin"
        ></menu-list>
     </div>
     <!-- Laboratory inside the student group to avoid extra spacing below -->
     <menu-list v-if="isLabUser" :item="labMenuItem" :companyID="companyID"></menu-list>
   </div>
   <!-- File Automate company - show only VAT Monthly -->
   <div v-if="isFileAutomateCompany">
     <div
       v-for="(item, idx) in filteredItemsFileAutomate"
       :key="`fileauto_${idx}`"
     >
       <menu-list
         :item="item"
         :companyID="companyID"
         :groupState="groupState"
         @toggle-group="handleToggleGroup"
       ></menu-list>
     </div>
   </div>
   <!-- otherwise, fall back to the normal AP-Automate items -->
   <div
     v-else-if="isValid(selectedCompanyProductList?.isApAutomate) && !isStudentCompany"
     class=""
   >
     <div
      v-for="(item, idx) in filteredApAutomateItems"
       :key="`apauto_${idx}`"
     >
       <menu-list
         v-if="!item.onlydev || (userCompany?.isDeveloper || userCompany?.user?.isEngineer)"
         :item="item"
         :companyID="companyID"
         :isCompanyAdmin="userCompany?.isAdmin"
         :groupState="groupState"
         @toggle-group="handleToggleGroup"
       ></menu-list>
     </div>
   </div>

      <!-- if none of those are true, then show the default menu -->
      <template v-if="
      !isValid(selectedCompanyProductList?.isEtax) && 
      !isValid(selectedCompanyProductList?.isPdfDoc) && 
      !isValid(selectedCompanyProductList?.isExchangeRate) && 
      !isValid(selectedCompanyProductList?.isTopserv)  && 
      !isValid(selectedCompanyProductList?.isNsThaiSmartTax) && 
      !isValid(selectedCompanyProductList?.isApAutomate) && 
      !isValid(selectedCompanyProductList?.isNsThaiSmartTaxAverage) && 
      !isValid(selectedCompanyProductList?.isFixedAssetCount) && 
      !isValid(selectedCompanyProductList?.isLab)">
        <div v-for="(item, index) in filteredItemsPSC" :key="index">
          <menu-list
            :item="item"
            :companyID="companyID"
            :groupState="groupState"
            @toggle-group="handleToggleGroup"
          ></menu-list>
        </div>
      </template>
      <!-- NS Fixed asset count -->
      <!-- Passes groupState + toggle handler so the "Fixed Asset"
           header (isHeader + groupId="ns-fixed-asset") can collapse its
           List / Count children. Same wiring as etax and NS TST. -->
     <div v-if="isValid(selectedCompanyProductList?.isFixedAssetCount)">
        <div v-for="(item, index) in itemsNsFixedAsset" :key="index + '_nsfixedasset'">

         <menu-list
           :item="item"
           :companyID="companyID"
           :isFixedAssetCount="isValid(selectedCompanyProductList?.isFixedAssetCount)"
           :groupState="groupState"
           @toggle-group="handleToggleGroup"
         ></menu-list>
        </div>
      </div>
      <div v-if="!isItemLoading && !isStudentCompany">
        <menu-list :item="itemsSetting" :companyID="companyID"></menu-list>
      </div>
    </v-list>
    <!-- loading indicator -->
    <div v-else style="margin-top: 10%">
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      <div class="tw-ml-20 tw-mr-10">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      <div class="tw-ml-20 tw-mr-10">
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
        <v-skeleton-loader type="paragraph"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import MenuList from "@/components/admin/navigation/list.vue";
import router from "@/router";
import fc from "@/firebaseConfig";
import { historyPageEnabled } from "@/libs/exchangeRateExport";
const PRODUCT_GROUP = {
  PSC: "PSC",
  PDFAI: "PDFAI",
  FRX: "FRX",
};

// Removed hardcoded company IDs - now using isLab field from Firebase

// admin-main-template is embedded in every route component (not a shared
// layout), so this drawer remounts on every route change and any plain
// component-data state is lost. Persisting the user's expand/collapse
// choices via localStorage keeps them stable across navigation and
// across full reloads. Wrapped in try/catch for privacy-mode browsers.
const GROUP_STATE_STORAGE_KEY = "navDrawer.groupState";
const DEFAULT_GROUP_STATE = {
  "ap-automate": true,
  "vat": true,
  "wht": true,
  "pp36": true,
  "pnd54": true,
  "report": true,
  "revenue-department": true,
  "etax-docs-sale": true,
  "ns-fixed-asset": true,
};
const readGroupState = () => {
  try {
    const raw = localStorage.getItem(GROUP_STATE_STORAGE_KEY);
    if (!raw) return { ...DEFAULT_GROUP_STATE };
    const parsed = JSON.parse(raw);
    // Merge defaults so any newly-added groupId still gets an entry.
    return { ...DEFAULT_GROUP_STATE, ...parsed };
  } catch (e) {
    return { ...DEFAULT_GROUP_STATE };
  }
};
const writeGroupState = (state) => {
  try {
    localStorage.setItem(GROUP_STATE_STORAGE_KEY, JSON.stringify(state));
  } catch (e) { /* storage unavailable — ignore */ }
};

export default {
  name: "NavigationDrawer",
  data: () => ({
    companyID: "",
    vendorListMerged: false,
    currentItems: [],
    unsubscribe: [],
    groupState: readGroupState(),
    labMenuItem: {
      icon: "lab-svgrepo-com_setting.svg",
      icon_active: "lab-svgrepo-com_setting_active_white.svg",
      text: "Laboratory",
      link: "Company.Laboratory",
    },
  }),
  components: {
    MenuList,
  },
  computed: {
    ...mapState({
      userCompany: (state) => state.user.userCompany,
      drawer: (state) => state.drawer.open,
      itemsPSC: (state) => state.drawer.itemsPSC,
      isItemLoading: (state) => state.drawer.isItemLoading,
      itemsVendor: (state) => state.drawer.itemsVendor,
      itemsExchangeRate: (state) => state.drawer.itemsExchangeRate,
      exchangePageSetting: (state) => state.exchangeRate.pageSetting,
      itemsNsThaiSmartTax: (state) => state.drawer.itemsNsThaiSmartTax,
      itemsNsFixedAsset: (state) => state.drawer.itemsNsFixedAsset,
      itemsTKC: (state) => state.drawer.itemsTKC,
      itemsApAutomate: (state) => state.drawer.itemsApAutomate,
      itemsApAutomateStudent: (state) => state.drawer.itemsApAutomateStudent,
      itemsFileAutomate: (state) => state.drawer.itemsFileAutomate,
      itemsSetting: (state) => state.drawer.itemsSetting,
      vendorPOList: (state) => state.drawer.vendorPOList,
      vendorSOList: (state) => state.drawer.vendorSOList,
      selectedCompanyAutoDocConfig: (state) => state.companies.selectedCompanyAutoDocConfig,
      selectedCompanyProductList: (state) => state.companies.selectedCompanyProductList,
    }),
    // Settings > อัตราแลกเปลี่ยน can turn the history page off per company.
    visibleExchangeItems() {
      const setting = this.exchangePageSetting;
      const hideHistory = setting.companyId === this.companyID && !historyPageEnabled(setting);
      return (this.itemsExchangeRate || []).filter(
        (item) => !(hideHistory && item.link === "Company.ExchangeHistory")
      );
    },
    filteredApAutomateItems() {
      // Show Upload Doc only when isApAutomateType === 1
      const type = this.selectedCompanyProductList?.isApAutomateType;
      return (this.itemsApAutomate || []).filter((item) => {
        if (item.link === 'Company.AccountsPayableUpload') {
          return type === 1;
        }
        // Filter items based on excludeCompanyIds property
        if (item.excludeCompanyIds && Array.isArray(item.excludeCompanyIds)) {
          if (item.excludeCompanyIds.includes(this.companyID)) {
            return false;
          }
        }
        // Filter items based on onlyCompanyIds property
        if (item.onlyCompanyIds && Array.isArray(item.onlyCompanyIds)) {
          return item.onlyCompanyIds.includes(this.companyID);
        }
        return true;
      });
    },
    // Items flagged requiresLaoTaxRis (the "sent to Lao eTax" page) only mean
    // something to a company that files with the Lao MoF gateway.
    filteredItemsPSC() {
      const isLao = !!this.selectedCompanyProductList?.isLaoTaxRis;
      return (this.itemsPSC || []).filter((item) => !item.requiresLaoTaxRis || isLao);
    },
    filteredItemsVendor() {
      // Filter items based on onlyCompanyIds property
      return (this.itemsVendor || []).filter((item) => {
        if (item.onlyCompanyIds && Array.isArray(item.onlyCompanyIds)) {
          return item.onlyCompanyIds.includes(this.companyID);
        }
        return true; // Show item if no onlyCompanyIds restriction
      });
    },
    isStudentCompany() {
      // Check if the company has isLab field set to true in selectedCompanyProductList
      return this.selectedCompanyProductList?.isLab === true;
    },
    filteredStudentMenu() {
      // --- เงื่อนไขเดิม (commented out): ---
      // if (this.userCompany?.isAdmin || this.userCompany?.role === "admin") {
      //   return this.itemsApAutomateStudent;
      // }
      // return this.itemsApAutomateStudent.filter(
      //   (item) => item.link === "Company.AccountsPayableStudent"
      // );
      // --- ปัจจุบัน: แสดงทุกเมนู ไม่สน role ---
      return this.itemsApAutomateStudent;
    },
    filteredItemsFileAutomate() {
      return (this.itemsFileAutomate || []).filter((item) => {
        if (item.onlyCompanyIds && Array.isArray(item.onlyCompanyIds)) {
          if (item.onlyCompanyIds.includes(this.companyID)) {
            return true;
          }
        }
        return false;
      });
    },
    isFileAutomateCompany() {
      // Only show File Automate menu for specific company ID
      return this.companyID === 'ykS6XoISZIaaVt9k9wB7';
    },
    isLabUser() {
      const user = fc.auth.currentUser
      return user && user.uid === 'rdcfVYk5wweay8cwYVSNZyWHztX2'
    },
  },
  created() {
    this.companyID = this.$route.params.companyId;
    // if (this.companyID === "Eh3hXbMX82kanH0deWiv") {
      this.getCompanyAutoDocConfig();
      this.getCompanyProductList();
      this.revealMenuIfReady();
      this.loadExchangeSetting();
    // }

    if (this.companyID) {
      this.$store.dispatch("user/getRoleUser", { companyId: this.companyID });
    }

  },
  beforeDestroy() {
      this.unsubscribe.forEach((unsubscribe) => {
        unsubscribe();
      });
  },
  methods: {
     isCompanyAdminCheck(item) {
    return item.isOnlyAdmin && (
      !item.onlydev ||
      (this.userCompany?.isDeveloper || this.userCompany?.user?.isEngineer)
    );
  },
    handleToggleGroup(groupId, isExpanded) {
      this.$set(this.groupState, groupId, isExpanded);
      writeGroupState(this.groupState);
    },
    getCompanyAutoDocConfig() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getCompanyAutoDocConfig", { companyId });
    },
    getCompanyProductList() {
      let companyId = this.$route.params.companyId;
      // The route guard (isCompanyAccessBlocked) already loads this company's
      // product list into the store on entry. Skip the duplicate network read
      // when it's present; fall back to fetching if the guard didn't populate
      // it, and clear the loading flag the guard doesn't touch.
      const c = this.$store.state.companies;
      if (
        c.selectedCompany.companyId === companyId &&
        Object.keys(c.selectedCompanyProductList || {}).length
      ) {
        this.$store.commit("companies/setProductListLoading", false);
        return;
      }
      this.$store.dispatch("companies/getCompanyProductList", { companyId });
    },
    // Reveal the menu as soon as the product list it renders from is loaded,
    // instead of waiting for the AutoDocConfig listener (vendor merge) to fire.
    // Vendor/AP items still merge in later via mergeVendorList.
    loadExchangeSetting() {
      if (!this.companyID || !this.isValid(this.selectedCompanyProductList?.isExchangeRate)) return;
      // Cached per company in the store; a failed read leaves the menu as is.
      this.$store
        .dispatch("exchangeRate/loadPageSetting", { companyId: this.companyID })
        .catch(() => {});
    },
    revealMenuIfReady() {
      const pl = this.$store.state.companies.selectedCompanyProductList;
      if (pl && Object.keys(pl).length) {
        this.$store.commit("drawer/setIsItemLoading", { newValue: false });
      }
    },
    isValid(value) {
      return (
        value !== undefined && value !== null && value !== "" && value === true
      );
    },
    goHome: function () {
      router.push("/");
    },
    mergeVendorListOnce() {
      this.$store.commit("drawer/mergeVendorList");
      this.$store.commit("drawer/setVendorListMerged");
    },
    setNewPOList() {
      // console.log("setNewPOList -> selectedCompanyAutoDocConfig", this.selectedCompanyAutoDocConfig.length)

      const newPoList = this.selectedCompanyAutoDocConfig.map((item) => ({
        text: item.vendorName,
        link: "Company.DocumentPOAIVendor",
        vendorCode: item.vendorCode,
      }));

      //check if item inside vendorPoList is different from newPoList

      const isDifferent =
        JSON.stringify(this.vendorPOList) !== JSON.stringify(newPoList);

      if (
        !this.$store.state.drawer.vendorListMerged ||
        this.vendorPOList.length !== newPoList.length ||
        isDifferent
      ) {
        this.$store.commit("drawer/setVendorPOList", newPoList);
        this.mergeVendorListOnce();
      }
    },
    setNewVendorList() {
      // console.log("setNewPOList -> selectedCompanyAutoDocConfig", this.selectedCompanyAutoDocConfig.length)
      

      const newPoList = this.selectedCompanyAutoDocConfig.map((item) => ({
        text: item.vendorName,
        link: "Company.DocumentPOAIVendor",
        subIcon: item.logo,
        vendorCode: item.vendorCode,
        group: PRODUCT_GROUP.PDFAI,
      }));
      const newSoList = this.selectedCompanyAutoDocConfig.map((item) => ({
        text: item.vendorName,
        link: "Company.DocumentSOAIVendor",
        subIcon: item.logo,
        vendorCode: item.vendorCode,
        group: PRODUCT_GROUP.PDFAI,
      }));

      //check if item inside vendorPoList is different from newPoList

      const isDifferent =
        JSON.stringify(this.vendorPOList) !== JSON.stringify(newPoList);
      const isDifferentSO =
        JSON.stringify(this.vendorSOList) !== JSON.stringify(newSoList);

      if (
        !this.$store.state.drawer.vendorListMerged ||
        isDifferent ||
        isDifferentSO
      ) {
        this.$store.commit("drawer/setVendorPOList", newPoList);
        this.$store.commit("drawer/setVendorSOList", newSoList);
        this.mergeVendorListOnce();
      }
    },
    setTkcItem(){
      const companyId = this.$route.params.companyId;
      const snapshot = fc.companies.doc(companyId).collection("TopservInvoiceSettings").doc("TOPSERV").onSnapshot(
        (doc) => {
          if (doc.exists) {
            const data = doc.data();
            const tkcItem = data.branches.map((item) => ({
              text: `สาขา${item.branchName} (${item.endsWith})`,
              link: "Company.DocumentTOPSERVBranch",
              endsWith: item.endsWith,
            }));
            this.$store.commit("drawer/setitemsTKC", tkcItem);
          }
        }
      );
      this.unsubscribe.push(snapshot);
    }
  },
  watch: {
    selectedCompanyAutoDocConfig() {
      // this.setNewPOList();
      this.setNewVendorList();
      // console.log("Watch -> selectedCompanyAutoDocConfig", this.selectedCompanyAutoDocConfig.length)
    },
    selectedCompanyProductList() {
      this.revealMenuIfReady();
      this.loadExchangeSetting();
      if (this.selectedCompanyProductList?.isTopserv) {
        this.setTkcItem();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-list {
  margin-bottom: 100px;
}
</style>
